import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Chatbot.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ThreeDots } from 'react-loader-spinner';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const handleChatToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSendMessage = async () => {
    if (userInput.trim() === "") return;

    const userMessage = { role: "user", content: userInput };

    // Add user message and loading placeholder
    setMessages(prevMessages => [
      ...prevMessages,
      userMessage,
      { role: "assistant", content: "typing...", isLoading: true }
    ]);

    setUserInput("");
    setLoading(true);

    try {
      const response = await axios.post(
        'https://api.groq.com/openai/v1/chat/completions',
        {
          model: "llama3-8b-8192",
          messages: [
            { role: "system", content: "You are an AI tutor on an EdTech platform. Users will ask questions, and your role is to clarify their doubts and provide helpful answers related to their courses." },
            userMessage
          ]
        },
        {
          headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`,
            'Content-Type': 'application/json',
          }
        }
      );

      const botMessage = response.data.choices[0].message.content;

      // Replace loading message with actual bot message
      setMessages(prevMessages => {
        const updated = [...prevMessages];
        updated[updated.length - 1] = { role: "assistant", content: botMessage };
        return updated;
      });

    } catch (error) {
      console.error("Error fetching the chatbot response", error);
      setMessages(prevMessages => {
        const updated = [...prevMessages];
        updated[updated.length - 1] = {
          role: "assistant",
          content: "Sorry, something went wrong. Please try again."
        };
        return updated;
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseChat = () => {
    setIsOpen(false);
    setMessages([]);
  };

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [messages]);

  return (
    <div>
      <button onClick={handleChatToggle} className="chat-button">🤖</button>

      {isOpen && (
        <div className="chat-window">
          <div className="message-area">
            <h4>SkillzVerse Chatbot</h4>

            {messages.length === 0 && (
              <div className="message assistant">
                <p>Have any doubts or questions related to your course? Feel free to ask!</p>
              </div>
            )}

            {messages.map((message, index) => (
              <div key={index} className={`message ${message.role}`}>
                {message.isLoading ? (
                  <ThreeDots color="#17a2e1" height={12} width={31} />
                ) : (
                  message.content
                )}
              </div>
            ))}

            <div ref={messagesEndRef} />
          </div>

          <input
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
            placeholder="Type your message"
            className="chatbot-input-box"
            disabled={loading}
          />

          <button
            onClick={handleSendMessage}
            className="send-button"
            disabled={loading || userInput.trim() === ""}
          >
            Send
          </button>

          <button onClick={handleCloseChat} className="close-button">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
